import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/home/HomeView.vue";
import TycView from "../views/home/Tyc.vue";
import HomeViewBanner from "../views/home/HomeViewBanner.vue";
import QuoteView from "../views/quote/QuoteView.vue";
import NewPlanView from "../views/panel/funds/new-plan/NewPlanView.vue";
import ChangePaymentMethodView from "../views/panel/funds/change-payment-method/ChangePaymentMethodView.vue";
import UsersPoliciesView from "../views/user-policies/UsersPoliciesView.vue";
import AdditionalContributionView from "../views/panel/funds/additional-contribution/AdditionalContributionView.vue";
import SinglePaymentView from "../views/panel/funds/single-payment/SinglePaymentView.vue"
import AdminPoliciesViewVue from "@/views/admin/admin-policies-view/AdminPoliciesView.vue";
import AdminEditPoliceViewVue from "@/views/admin/admin-edit-police-view/AdminEditPoliceView.vue";
import AdminOperationsViewVue from "@/views/admin/admin-operations-view/AdminOperationsView.vue";
import AdminPaymentsUploadViewVue from "@/views/admin/admin-payments-view/AdminPaymentsUploadView.vue";
import AdminPromotionsUploadView from "@/views/admin/admin-promotions-view/AdminPromotionsUploadView.vue";
import AdminDataConsistency from "@/views/admin/admin-data-consistency/AdminDataConsistency.vue";
import AdminUserPersistency from "@/views/admin/admin-user-persistence/AdminUserPersistency.vue";

let home = null;
const randomViewNumber = Math.floor(Math.random() * 2) + 1;
home = HomeView;
/*if (randomViewNumber === 1) {
    home = HomeView;
} else {
    home = HomeViewBanner;
}*/

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: HomeView,
    },
    {
        path: "/v2",
        name: "homev2",
        component: HomeView,
    },
    {
        path: "/tyc",
        name: "tyc",
        component: TycView,
    },
    {
        path: "/quote",
        name: "quote",
        component: QuoteView,
    },
    {
        path: "/client-zone/policies",
        name: "policies",
        component: UsersPoliciesView,
    },
    {
        path: "/client-zone/new-plan",
        name: "newplan",
        component: NewPlanView,
    },
    {
        path: "/client-zone/change-payment-method/:id",
        name: "changepaymentmethod",
        component: ChangePaymentMethodView,
    },
    {
        path: "/client-zone/additional-contribution/:id",
        name: "additionalcontribution",
        component: AdditionalContributionView
    },
    {
        path: "/client-zone/single-payment/:id",
        name: "singlepayment",
        component: SinglePaymentView
    },
    {
        path: "/admin/policies",
        name: "adminpolicies",
        component: AdminPoliciesViewVue
    },
    {
        path: "/admin/edit-policy",
        name: "admineditpolicy",
        component: AdminEditPoliceViewVue
    },
    {
        path: "/admin/operations",
        name: "adminoperations",
        component: AdminOperationsViewVue
    },
    {
        path: "/admin/payments-upload",
        name: "adminpaymentsupload",
        component: AdminPaymentsUploadViewVue
    },
    {
        path: "/admin/promos-upload",
        name: "adminpromosupload",
        component: AdminPromotionsUploadView
    },
    {
        path: "/admin/data-consistency",
        name: "dataconsistency",
        component: AdminDataConsistency
    },
    {
        path: "/admin/persistence",
        name: "datapersistence",
        component: AdminUserPersistency
    }
];

const router = createRouter({
    history: createWebHistory('/seguro-de-vida/rumbo/'),
    routes,
});

export default router;
